<div mat-dialog-title class="d-flex align-items-center justify-content-between">
	<div class="dialog-title-text">Session Expired</div>
    <button mat-icon-button aria-label="close dialog" mat-dialog-close tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
	<div class="text-center">
		<img src="{{ s3Asset }}/image/session_expired.png" height="180px" class="mb-4">
		<div class="mb-2"><strong>Oops, your session has expired</strong></div>
		<div>Your session has expired due to your inactivity.</div>
		<div>Don't worry, you can simply login again.</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-flat-button color="accent" (click)="backToLogin()">Login</button>
</mat-dialog-actions>
